// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';

let autoScroll = true;

let observers = [];
let presentSteps = [];
let collage = document.querySelector('.collage');

let topDist = window.scrollY;

function setUpObservers() {
  createObserver({
    root: null,
    rootMargin: `${document.querySelector('body').clientHeight}px 0px 40px 0px`,
    threshold: [0.01, 0.99],
    callback: peeps,
    step: '.step',
  });

  createObserver({
    root: null,
    rootMargin: `${document.querySelector('body').clientHeight}px 0px -90% 0px`,
    threshold: [0.01, 0.99],
    callback: blurIn,
    step: '.image-step',
  });

  createObserver({
    root: null,
    rootMargin: `${document.querySelector('body').clientHeight}px 0px -50% 0px`,
    threshold: [0.01, 0.99],
    callback: profileIn,
    step: '.profile-step',
  });

  // createObserver({
  //   root: null,
  //   rootMargin: `${document.height}px 0px 200px 0px`,
  //   threshold: [0.01, 0.99],
  //   callback: turnOff,
  //   step: '.appendix-wrapper',
  // });
}

// function turnOff(entries){
//   if(entries[0].isIntersecting){
//
//     document.querySelectorAll('#profiles .current').forEach((item, i) => {
//       item.classList.remove('current');
//     });
//
//   }
// }

function blurIn(entries) {
  entries.forEach((item, i) => {
    let presentStep = presentSteps[parseInt(item.target.dataset.global)];
    if (!item.isIntersecting) {
      item.target.classList.remove('on');
    } else {
      item.target.classList.add('on');
    }

    presentStep = item.target.dataset.index;
  });
}

function profileIn(entries) {
  document.querySelectorAll('.profile-step').forEach((prof, p) => {
    prof.classList.remove('current');
  });

  entries.forEach((item, i) => {
    let presentStep = presentSteps[parseInt(item.target.dataset.global)];
    if (item.target.dataset.index !== presentStep) {
      if (item.isIntersecting) {
        item.target.classList.add('current');
      } else {
        let currentNode = item.target.previousElementSibling;
        if (currentNode) {
          currentNode.classList.add('current');
        }
      }
    }
    presentStep = item.target.dataset.index;
  });
}

function createObserver(d) {
  let callback = d.callback;

  let options = {
    root: d.root,
    rootMargin: d.rootMargin,
    threshold: d.threshold,
  };

  let storedVals = [];

  observers.push(new IntersectionObserver(callback.bind(topDist), options));
  let ind = observers.length - 1;

  presentSteps.push(0);
  let currentObserver = observers[ind];
  let presentStep = presentSteps[ind];
  let currentInd = observers.length - 1;
  document.querySelectorAll(d.step).forEach((item, i) => {
    storedVals.push({ ind: i, y: Infinity, r: 0, entered: false });
    item.dataset.step = i;
    item.dataset.global = ind;
    currentObserver.observe(item);
  });
}

function peeps(entries) {
  entries.forEach((item, i) => {
    let presentStep = presentSteps[parseInt(item.target.dataset.global)];
    let block = document.querySelector(
      `.block[data-index="${item.target.dataset.index}"]`
    );
    if (item.target.dataset.index !== presentStep) {
      if (item.isIntersecting) {
        if (block) {
          block.classList.add('on');
        } else {
          if (item.target.dataset.index == 'scoot') {
            document.querySelector('.intro-steps').classList.add('scoot');
          } else if (item.target.dataset.index == 'end') {
            autoScroll = false;
          }
        }
      } else {
        if (block) {
          block.classList.remove('on');
        } else {
          autoScroll = true;
          if (item.target.dataset.index == 'scoot') {
            document.querySelector('.intro-steps').classList.remove('scoot');
          }
        }
      }
    }
    presentStep = item.target.dataset.index;
  });
}

window.addEventListener('load', function () {
  setUpObservers();

  scrollIntro();
  function scrollIntro() {
    if (autoScroll) {
      window.scrollBy(0, 1);
      window.requestAnimationFrame(scrollIntro);
    }
  }

  document.querySelectorAll('.snippet').forEach((item, i) => {
    item.addEventListener('click', function () {
      let parent = event.currentTarget.parentNode;

      document.querySelectorAll('#appendix .person').forEach((item, i) => {
        if (item.dataset.ind !== parent.dataset.ind) {
          item.classList.remove('show');
        }
      });
      parent.classList.toggle('show');
      if (window.matchMedia('(max-width:600px)').matches) {
        parent.scrollIntoView();
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  lazyload();
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});
